// src/components/LoginPage/index.js
import LoginPage from './LoginPage';
export default LoginPage;